<template>
    <div>
        <div class="main">
            <van-row type="flex" justify="center">
                <van-col span="24">
                    <h4 style="font-size:.5rem">积 分 商 城</h4>
                </van-col>
            </van-row>
        </div>
        <van-search
            shape="round"
            always
            background="#FFFFFF"
            v-model="value"
            input-align="center"
            placeholder="请输入搜索内容"
            @search="GetqueryIntegralCommodity"
        />
        <!-- <div class="tab">
            <van-row>
                <van-col span="8">
                    <div style="border: 0" class="tabs">全部</div>
                </van-col>
                <van-col span="8">
                    <div class="tabs">积分</div>
                </van-col>
                <van-col span="8">
                    <div class="tabs">筛选</div>
                </van-col>
            </van-row>
        </div> -->
        <div class="bodys">
            <van-grid clickable :column-num="2" :gutter="10">
                <van-grid-item @click="xiangqing(item.id)" v-for="item in PageList" :key="item.id">
                    <template #icon>
                        <div class="tabcolor">
                            <img
                                :src="imgurl + '/schoolPoints' + item.imgUrl.split('&')[0]"
                                alt=""
                            />
                            <p v-text="item.commodityName"></p>
                           <!-- <p>{{ item.commodityIntegral }}积分</p> -->
						  <div class="jflx" v-if="item.list!=''">
							<span><i>{{item.list[0].typeName}}</i>{{item.list[0].commodityIntegral}}</span>
							<span><i>{{item.list[1].typeName}}</i>{{item.list[1].commodityIntegral}}</span>
							<span><i>{{item.list[2].typeName}}</i>{{item.list[2].commodityIntegral}}</span>
							<span><i>{{item.list[3].typeName}}</i>{{item.list[3].commodityIntegral}}</span>
							<span><i>{{item.list[4].typeName}}</i>{{item.list[4].commodityIntegral}}</span>
						   </div>
                        </div>
                   </template>
                </van-grid-item>
            </van-grid>
        </div>
    </div>
</template>

<script>
import { integralCommodit_query,queryIntegralCommodity } from "./../../api/api";

export default {
    name: "exchange",
    data() {
        return {
            value: "",
            imgurl:"",
            PageList: [],
        };
    },
    methods: {
        xiangqing(id){
            this.$router.push("/xiangqin?id="+id)
        },
        GetqueryIntegralCommodity() {
            let data = {
                commodityName:this.value
            }
            integralCommodit_query(data).then((res) => {
                this.PageList = res.data.rows;
            });
        },
    },
    created() {
        this.imgurl = this.$store.state.HttpsUrl;
        this.GetqueryIntegralCommodity();
    },
};
</script>

<style lang="less" scoped>
.main {
    min-height: 1.72rem;
    background-color: #aa0018;

    h4 {
        text-align: center;
        color: #fff;
        height: 1.4rem;
        font-size: 0.6rem;
        margin: 0;
        margin-top: 1.2rem;
    }
    .selects,
    .buttons {
        width: 85%;
        position: relative;
        bottom: -0.7rem;
        left: 0.4rem;
        background: #f5f5f5;
        border-radius: 0.3rem;
        padding: 0.4rem 0.4rem;
        color: #666666;
        font-weight: normal;
        img {
            width: 0.4rem;
            float: right;
            margin-top: 0.1rem;
        }
    }
    .buttons {
        width: 1.6rem;
        margin: 0 0.8rem;
        color: #ffffff;
        font-weight: normal;
        left: 0;
        padding: 0.4rem 0.3rem;
        background: #d5c088;
        border-radius: 0.3rem;
    }
}
.tab {
    width: 100%;
    height: 0.9rem;
    padding-top: 0.4rem;
    background: #f5f5f5;
    .tabs {
        width: 100%;
        text-align: center;
        border-left: 0.05rem solid #666666;
        color: #666666;
        font-weight: normal;
    }
}
.bodys {
    padding: 0.2rem;
    margin-top: 0.5rem;
    padding-bottom:2rem;
}

.tabcolor {
    width: 100%;
    height: 100%;
    img{
        width: 100%;
        height:4.5rem;
    }
    p {
        width: 3.8rem;
        word-break:break-all;
        padding: 5px 0 0 5px;
        font-size: 0.4rem;
        font-weight: 600;
       /* &:last-child {
            color: red;
        } */
    }
}
 .jflx{
 	margin-top:0.2rem;
	padding-left: 5px;
 	span{
 		/* margin-left:0.4rem; */
 		width:50%;
 		margin-bottom: 0.4rem;
 		    display: inline-block;
 		i{
 			display:inline-block;
 			color:#aa0018;
 	font-style: initial;
 	width:1rem;
 	height:0.5rem;
 	border:1px solid #aa0018;
 	border-radius:4px;
 	font-size:0.1rem;
 	text-align:center;
 	margin-right:0.125rem;
 	
 	
 		}
 } }
</style>